import React, { useContext } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import { DataLayerEventContext } from '../../../contexts/dataLayerEventContext';

const shopLink = {
  rozetka:
    'https://rozetka.com.ua/ua/sigareti/c4638591/filter/price=1700-1700;producer=parliament/?utm_source=PMUsms1CaratBlue',
  cigPoshta:
    'https://cig-poshta.in.ua/ru/shop/parliament-ru/swoof/price-1700-to-1700/?utm_source=CDAsms1CaratBlue'
};

const HomeScreen = () => {
  const { sendEvent } = useContext(DataLayerEventContext);
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <img
          src={getImageFromS3('images/sms-prl-crt-blue/crystal.gif')}
          alt="crystal-bg"
          className={styles.crystalGif}
        />
        <img
          src={getImageFromS3('images/sms-prl-crt-blue/city.png')}
          alt="city-bg"
          className={styles.city}
        />
        <div className={styles.blueShadow} />
        <img
          src={getImageFromS3('images/sms-prl-crt-blue/logo.png')}
          alt="logo"
          className={styles.logo}
        />
        <img
          src={getImageFromS3('images/sms-prl-crt-blue/packs.png')}
          alt="packs"
          className={styles.packs}
        />
        <div className={styles.blendContainer}>
          <img
            src={getImageFromS3('images/sms-prl-crt-blue/big-shadow.png')}
            alt="big-shadow"
            className={styles.bigShadow}
          />
          <img
            src={getImageFromS3('images/sms-prl-crt-blue/small-shadow.png')}
            alt="small-shadow"
            className={styles.smallShadow}
          />
          <img
            src={getImageFromS3('images/sms-prl-crt-blue/tobacco-blend.png')}
            alt="tobacco-blend"
            className={styles.tobaccoBlend}
          />
        </div>
        <div className={styles.textContainer}>
          <div className={styles.characteristicContainer}>
            <div>
              <img
                src={getImageFromS3('images/sms-prl-crt-blue/firstFilter.png')}
                alt="firstFilter"
              />
              <div>
                <p>
                  <b>Фільтр</b> з повітряною камерою
                </p>
              </div>
            </div>
            <div>
              <div>
                <p>
                  <b>Ацетатна частина</b>
                </p>
              </div>
              <img
                src={getImageFromS3('images/sms-prl-crt-blue/secondFilter.png')}
                alt="secondFilter"
              />
            </div>
            <div>
              <img
                src={getImageFromS3('images/sms-prl-crt-blue/thirdFilter.png')}
                alt="thirdFilter"
              />
              <div>
                <p>
                  <b>Вугільна частина</b>
                </p>
              </div>
            </div>
          </div>
          <div className={styles.buyContainer}>
            <p>Де купити</p>
            <p>
              Актуальний асортимент можна знайти у роздрібних точках продажу в
              твоєму місті або на офіційних онлайн сервісах, зокрема:
            </p>
            <div className={styles.linksContainer}>
              <button
                onClick={() => {
                  sendEvent('rozetka');
                  window.open(shopLink.rozetka, '_blank');
                }}
              >
                Rozetka
              </button>
              <button
                onClick={() => {
                  sendEvent('Cig-Poshta');
                  window.open(shopLink.cigPoshta, '_blank');
                }}
              >
                Cig-poshta
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        Куріння викликає серйозні захворювання та залежність Дана інформація про
        продукт надається відповідно до статті 15 Закону України «Про захист
        прав споживачів»
      </div>
      <div className={styles.unsubscribe}>
        Ти отримав(-ла) повідомлення, оскільки залишав(-ла) запит на отримання
        інформації про продукцію компаній Philip Morris в Україні. <br />
        <a href="/unsubscribe?returnLink=25-sms-prl-crt-blue">
          Відписатися від SMS тут.
        </a>
      </div>
    </div>
  );
};

export default HomeScreen;
